import {
  Injectable
} from '@angular/core';

import {
  Observable
} from 'rxjs';

import {
  HttpClient, HttpEvent, HttpParams
} from '@angular/common/http';

@Injectable()
export class ApiService {
  private endpoint = 'https://96kx13fd92.execute-api.ca-central-1.amazonaws.com/v1';
  private telehealthEndpoint = 'https://35tea71j5c.execute-api.us-east-1.amazonaws.com/v1';
  private resourceEndpoint = 'https://gjknyigv36.execute-api.ca-central-1.amazonaws.com/v1';
  private emrEndpoint = 'https://91c7ql6w0e.execute-api.ca-central-1.amazonaws.com';
  constructor(public httpClient: HttpClient) {

  }

  public getEMRProgress<T>(url: string, params?: HttpParams): Observable<HttpEvent<T>> {
    return this.httpClient.get<T>(`${this.emrEndpoint}${url}`,{ params, observe: "events", reportProgress: true } )
    //return this.http.get<T>(`${this.emrEndpoint}${url}`, { params, reportProgress: true } );
  }

  public getEMR<T>(url: string, params?: HttpParams): Observable<T> {
    return this.httpClient.get<T>(`${this.emrEndpoint}${url}`, { params } );
  }

  public postEMR<T>(url: string, body: any, params?: HttpParams): Observable<T> {
    return this.httpClient.post<T>(`${this.emrEndpoint}${url}`, body, { params } );
  }

  public getResource<T>(url: string, params?: HttpParams): Observable<T> {
    return this.httpClient.get<T>(`${this.resourceEndpoint}${url}`,{ params } )
  }

  public patchTelehealth<T>(url: string, body: any, params?: HttpParams): Observable<T> {
    return this.httpClient.patch<T>(`${this.telehealthEndpoint}${url}`, body, { params } );
  }

  public getTelehealth<T>(url: string, params?: HttpParams): Observable<T> {
    return this.httpClient.get<T>(`${this.telehealthEndpoint}${url}`, { params } );
  }

  public postTelehealth<T>(url: string, body: any, params?: HttpParams): Observable<T> {
    return this.httpClient.post<T>(`${this.telehealthEndpoint}${url}`, body, { params } );
  }

  public get<T>(url: string, params?: HttpParams): Observable<T> {
    return this.httpClient.get<T>(`${this.endpoint}${url}`, { params } );
  }

  public patch<T>(url: string, body: any, params?: HttpParams): Observable<T> {
    return this.httpClient.patch<T>(`${this.endpoint}${url}`, body, { params } );
  }

  public postURL<T>(url: string, body: any, params?: HttpParams): Observable<T> {
    return this.httpClient.post<T>(`${url}`, body, { params } );
  }

  public post<T>(url: string, body: any, params?: HttpParams): Observable<T> {
    return this.httpClient.post<T>(`${this.endpoint}${url}`, body, { params } );
  }

  public put<T>(url: string, body: any, params?: HttpParams): Observable<T> {
    return this.httpClient.put<T>(`${this.endpoint}${url}`, body, { params } );
  }

  public del<T>(url: string, params?: HttpParams): Observable<T> {
    return this.httpClient.delete<T>(`${this.endpoint}${url}`, { params } );
  }
  /*
  public post<T>(url: string, body: any, options?: RequestOptionsArgs): Observable<T> {
    return this.http.post(`${this.endpoint}${url}`, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public put<T>(url: string, body?: any, options?: RequestOptionsArgs): Observable<T> {
    return this.http.put(`${this.endpoint}${url}`, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public delete<T>(url: string, options?: RequestOptionsArgs): Observable<T> {
    return this.http.delete(`${this.endpoint}${url}`, options)
      .map(this.extractData)
      .catch(this.handleError);
  }


  public patch<T>(url: string, body: any, options?: RequestOptionsArgs): Observable<T> {
    return this.http.patch(`${this.endpoint}${url}`, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  private extractData<T>(resp: Response): T {
    return resp.json() || {};
  }

  private handleError<T>(error: Response): Observable<T> {
    return Observable.throw(error.json());
  }
*/
}
